import { useModal } from 'components/modals';
import { ChangePricingPlanModal } from 'features/pricing/modals/ChangePricingPlanModal';
import { usePostHog } from 'posthog-js/react';
import { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { GAEvents } from 'services/tracking/GAEvents';

export const UpdateSubscriptionModal = () => {
  const postHog = usePostHog();

  useEffect(() => {
    GAEvents.modalSeen({
      modal: 'Generic upgrade modal',
    });

    postHog?.capture('Upgrade modal seen', {
      modal: 'Generic upgrade modal',
    });
  }, [postHog]);

  return (
    <ChangePricingPlanModal
      headline={<FormattedMessage id="update_subscription.headline" values={{ br: <br /> }} />}
    />
  );
};

export function useShowUpdateSubscriptionModal() {
  const { showModal } = useModal();

  return () => showModal('UPDATE_SUBSCRIPTION', { size: 1100 });
}
